import { useState, useEffect } from 'react';
import Theme from '../../core-components/theme/theme';

function useIsDesktop(breakpoint = Theme.breakpoints.values.md) {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsDesktop(window.innerWidth > breakpoint);
    }

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isDesktop;
}

export default useIsDesktop;
